import React from "react";
import { useMediaQuery } from "@material-ui/core";
import { Grid, Hidden, Typography } from "@mui/material";

import { CloseRedIcon, SuccessIcon, WarningIcon } from "@components/Icons";
import Theme from "@components/Theme";

import { useForm } from "@pages/User/NewRequest/resources/context/FormContext";
import TableCustom from "@pages/User/NewRequest/resources/table/TableCustom";
import TableMobile from "@pages/User/NewRequest/resources/table/TableMobile";

import { ITableBody, THeadData } from "../ITableHeader";
import { formatterOrder } from "../formatter";

interface TableMessage {
  title: string;
  icon: JSX.Element | null;
  subTitle: string;
}

function defineTableMessage(orders): TableMessage {
  const errorCount = orders.filter((order) => order.atemStatus === "error")
    .length;
  const SUCCESS_TITLE = "Sucesso!";
  const ERROR_TITLE = "Falha!";
  const WARNING_TITLE = "Atenção!";
  const SUCCESS_SUBTITLE = "Seu pedido foi efetuado com sucesso! Confira:";
  const ERROR_SUBTITLE = "Infelizmente, seu pedido não pôde ser processado.";
  const WARNING_SUBTITLE =
    "Alguns pedidos foram processados com sucesso, mas outros não.";

  if (errorCount === 0) {
    return {
      title: SUCCESS_TITLE,
      subTitle: SUCCESS_SUBTITLE,
      icon: <SuccessIcon style={{ fontSize: 12 }} />,
    };
  } else if (errorCount === orders.length) {
    return {
      title: ERROR_TITLE,
      subTitle: ERROR_SUBTITLE,
      icon: <CloseRedIcon style={{ fontSize: 12 }} />,
    };
  } else {
    return {
      title: WARNING_TITLE,
      subTitle: WARNING_SUBTITLE,
      icon: <WarningIcon style={{ fontSize: 12 }} />,
    };
  }
}
const TableSuccessMessage: React.FC = () => {
  const { newOrders } = useForm();

  const isMobile = useMediaQuery(Theme.breakpoints.only("xs"));
  let tableMessage: TableMessage = defineTableMessage(newOrders);

  return (
    <Grid
      container
      gap={1.5}
      sx={{ border: "1px solid #E0E0E0", borderRadius: 2, padding: 2 }}
    >
      <Grid item xs={12}>
        <Grid container gap={1} alignItems={"center"}>
          <Grid item>{tableMessage.icon}</Grid>
          <Grid item>
            <Typography variant="h5" sx={{ margin: "0rem", fontWeight: 700 }}>
              {tableMessage.title}
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Typography
          style={{
            fontFamily: "DM Sans",
            color: "#3E3D3D",
            fontSize: isMobile ? 14 : 12,
            opacity: 0.7,
            textAlign: "left",
          }}
        >
          {tableMessage.subTitle}
        </Typography>
      </Grid>
    </Grid>
  );
};

const TablePageNewRequest: React.FC = () => {
  const { newOrders } = useForm();

  const TBodyData: ITableBody[] = newOrders.map((order) => {
    return formatterOrder(order);
  });

  return (
    <Grid container gap={2}>
      <Grid item xs={12}>
        <TableSuccessMessage />
      </Grid>

      <Grid item xs={12}>
        <Hidden mdDown>
          <TableCustom THead={THeadData} TBody={TBodyData}></TableCustom>
        </Hidden>

        <Hidden mdUp>
          <TableMobile THead={THeadData} TBody={TBodyData} />
        </Hidden>
      </Grid>
    </Grid>
  );
};

export default TablePageNewRequest;
